class ProductColours extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['title', 'colour']
  }

  currentTitle = this.els.title.element.dataset.defaultColour

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (!this.els?.colour?.exists) return

    if (!window.BAO.MediaBreakpoints.isSm) return

    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)

    this.els.colour.elements.forEach((colour) => {
      this.listeners.add(colour, 'mouseenter', this.handleMouseEnter)
      this.listeners.add(colour, 'mouseleave', this.handleMouseLeave)
    })
  }

  handleMouseEnter (e) {
    this.els.title.element.textContent = e.currentTarget.dataset.title
  }

  handleMouseLeave (e) {
    if (this.currentTitle !== e.currentTarget.dataset.title) {
      this.els.title.element.textContent = this.currentTitle
    }
  }
}

if (!customElements.get('product-colours')) {
  customElements.define('product-colours', ProductColours)
}
